import { render, staticRenderFns } from "./PaymentTransactionList.vue?vue&type=template&id=461208ea"
import script from "./PaymentTransactionList.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionList.vue?vue&type=script&lang=js"
import style0 from "./PaymentTransactionList.vue?vue&type=style&index=0&id=461208ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports